<template>
  <!-- summary table -->
  <div style="max-width:100%; overflow-x:auto;">
    <table
      style="width:auto;white-space: nowrap;"
      class="table table-condensed text-center"
      v-if="stats!=null"
    >
      <tbody>
        <tr>
          <vs-card>
            <ul class="statistic">
              <li>
                <h3 v-if="stats[0].Orders!=null">{{stats[0].Orders}}</h3>
                <h3 v-else>0</h3>
                <div>Orders</div>
              </li>
              <li>
                <h3 v-if="stats[0].Paid!=null">{{stats[0].Paid}}</h3>
                <h3 v-else>0</h3>
                <div>Paid</div>
              </li>
              <li>
                <h3 v-if="stats[0].PaidRatio!=null">{{stats[0].PaidRatio}}</h3>
                <h3 v-else>0</h3>
                <div>Rate</div>
              </li>
              <li>
                <h3 v-if="stats[0].Revenue!=null">{{stats[0].Revenue}}</h3>
                <h3 v-else>0</h3>
                <div>Revenue</div>
              </li>
              <li>
                <h3 v-if="stats[0].PaymentPending!=null">{{stats[0].PaymentPending}}</h3>
                <h3 v-else>0</h3>
                <div>Pending</div>
              </li>
              <li>
                <h3 v-if="stats[0].Tickets!=null">{{stats[0].Tickets}}</h3>
                <h3 v-else>0</h3>
                <div>Tickets</div>
              </li>
            </ul>
          </vs-card>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "summary-order",
  components: {},
  props: {
    stats: null
  },
  data: () => ({})
};
</script>